import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid, regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import CallLogsSearchBox from '../components/CallLogsSearchBox';
import CallLogsPagination from '../components/CallLogsPagination';
import { useNavigate, useParams } from 'react-router-dom';
import { Listbox, Transition } from '@headlessui/react';
import { fetchTicketsByPhone } from '../api/zoho';
import Loader from '../components/Loader';
import { Toaster, ToastIcon, toast, resolveValue } from 'react-hot-toast';
import axiosx from '../axios/index';
import { useQuery } from 'react-query';
import { useDropdown } from '../store/dropdown-context';
import { getDatePlusHours } from '../utils/date';
const TailwindToaster = () => {
  return (
    <Toaster>
      {(t) => (
        <Transition
          appear
          show={t.visible}
          className='transform p-4 flex bg-white rounded shadow-lg'
          enter='transition-all duration-150'
          enterFrom='opacity-0 scale-50'
          enterTo='opacity-100 scale-100'
          leave='transition-all duration-150'
          leaveFrom='opacity-100 scale-100'
          leaveTo='opacity-0 scale-75'
        >
          <ToastIcon toast={t} />
          <p className='px-2'>{resolveValue(t.message)}</p>
        </Transition>
      )}
    </Toaster>
  );
};
const people = ['عرض الكل', 'عرض الأرشيف', 'عرض المثبتة'];

const CalLlogsScreen = () => {
  let { phoneNumber } = useParams();
  const { agentNameContext } = useDropdown();
  window.scrollTo(0, 0);
  const getTictets = async ({ queryKey }) => {
    try {
      setLoading(true);
      const response = await axiosx.get(`/ticket/tickets/${queryKey[1]}`);
      if (response.data.success === false) {
        if (response.data.error.response.status == 404) {
          setLoading(false);
          toast.error('لا يوجد بيانات لعرضها');
          setTimeout(() => {}, 2500);
          navigate(`/${phoneNumber}/${agentNameContext}`);
          // navigate(`/IncomingCallScreen/${phoneNumber}`);
        } else {
          setLoading(false);
          toast.error('لا يوجد بيانات لعرضها');
          setTimeout(() => {}, 2500);
          navigate(`/${phoneNumber}/${agentNameContext}`);
        }
      }
      if (response.data.success === true) {
        if (response.data?.data?.length > 0) {
          setLoading(false);
          toast.success('تم تحميل البيانات بنجاح');
          return response.data.data;
        } else {
          setLoading(false);
          toast.error('لا يوجد بيانات لعرضها');
          setTimeout(() => {}, 2500);
          navigate(`/${phoneNumber}/${agentNameContext}`);
        }
      } else {
        return [];
      }
      setLoadding(false);
    } catch (error) {
      console.log(error);
    }
  };
  const { data, isLoading, isError } = useQuery(
    ['tickets', phoneNumber],
    getTictets,
    {
      refetchOnWindowFocus: false,
    }
  );

  const [selectedPerson, setSelectedPerson] = useState(people[0]);
  const [loading, setLoading] = useState(false);

  let { keyword, pageNumber, pageSize } = useParams();
  keyword = keyword || '';
  pageNumber = pageNumber || 1;
  pageSize = pageSize || 20;

  const [loadding, setLoadding] = useState(false);
  const [error, setError] = useState('');
  let navigate = useNavigate();
  useEffect(() => {
    setError('');
  }, []);

  return (
    <div className='flex flex-col bg-grayblack-300 py-16 min-h-screen'>
      <div className='-my-2 overflow-x-auto '>
        <div className='py-2 align-middle inline-block min-w-full px-6 sm:px-6 lg:px-10 3xl:px-96'>
          {/* <TicketListSearchBox /> */}
          <h2 className='text-2xl font-extrabold tracking-tight text-title-100 text-center pb-16'>
            سجل المكالمات
          </h2>
          <div className='  '>
            <button
              type='button'
              onClick={() => navigate(`/${phoneNumber}/${agentNameContext}`)}
              className=' text-white bg-button-100 hover:bg-blue-800  rounded-md  font-medium  text-sm px-10 py-2     '
            >
              رجوع
            </button>
          </div>
          <div className='shadow overflow-hidden border-b border-gray-200 sm:rounded-lg'>
            {!loading ? (
              <table className='w-full divide-y divide-gray-200' dir='rtl'>
                <thead className='bg-gray-50'>
                  <tr>
                  <th
                      scope='col'
                      className=' px-6 py-3 text-right text-sm  font-medium text-gray-500 uppercase tracking-wider'
                    >
                      #
                    </th>
                    <th
                      scope='col'
                      className=' px-6 py-3 text-right text-sm  font-medium text-gray-500 uppercase tracking-wider'
                    >
                      رقم المكالمة
                    </th>
                    <th
                      scope='col'
                      className=' px-6 py-3 text-right text-sm  font-medium text-gray-500 uppercase tracking-wider'
                    >
                      نوع المكالمة
                    </th>
                    <th
                      scope='col'
                      className=' px-6 py-3 text-right text-sm  font-medium text-gray-500 uppercase tracking-wider'
                    >
                      الحالة
                    </th>
                    <th
                      scope='col'
                      className=' px-6 py-3 text-right text-sm  font-medium text-gray-500 uppercase tracking-wider'
                    >
                      اسم العميل
                    </th>

                    <th
                      scope='col'
                      className=' px-6 py-3 text-right text-sm  font-medium text-gray-500 uppercase tracking-wider'
                    >
                      حساب العميل ERP
                    </th>
                    <th
                      scope='col'
                      className='px-4 py-3 text-right text-sm  font-medium text-gray-500 uppercase tracking-wider'
                    >
                      رقم الهاتف
                    </th>
                    <th
                      scope='col'
                      className=' px-6 py-3 text-right text-sm  font-medium text-gray-500 uppercase tracking-wider'
                    >
                      المدينة
                    </th>
                    <th
                      scope='col'
                      className=' px-6 py-3 text-right text-sm  font-medium text-gray-500 uppercase tracking-wider'
                    >
                      الضاحية
                    </th>

                    <th
                      scope='col'
                      className='px-6 py-3 text-right text-sm  font-medium text-gray-500 uppercase tracking-wider'
                    >
                      أنشئت في
                    </th>
                    <th
                      scope='col'
                      className='px-6 py-3 text-right text-sm  font-medium text-gray-500 uppercase tracking-wider'
                    >
                      تم التعديل في
                    </th>
                    <th
                      scope='col'
                      className='px-6 py-3 text-right text-sm  font-medium text-gray-500 uppercase tracking-wider'
                    >
                      اسم الموظف
                    </th>
                    <th scope='col' className='relative px-6 py-3'>
                      <span className='sr-only'>تفاصيل</span>
                    </th>
                  </tr>
                </thead>

                <tbody className='bg-white divide-y divide-gray-200 '>
                  {data?.map((ticket) => (
                    <tr key={ticket.id}>
                      <td className='px-6 py-4 whitespace-nowrap '>
                        <div className='flex items-center'>
                          <div className='ml-4'>
                            <div className='text-sm text-right font-medium text-gray-900'>
                              {ticket?.id}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className='px-6 py-4 whitespace-nowrap '>
                        <div className='flex items-center'>
                          <div className='ml-4'>
                            <div className='text-sm text-right font-medium text-gray-900'>
                              {ticket?.ticketNumber}
                            </div>
                          </div>
                        </div>
                      </td>

                      <td className='px-6 py-4 whitespace-nowrap '>
                        <div className='text-sm text-right text-altaqnya-100'>
                          {/* <button
                          onClick={() => numberHandler(ticket?.number)}
                        > */}
                          {ticket?.cf?.cf_nw_almkalmt === 'طلب خدمة'
                            ? `${ticket?.cf?.cf_nw_almkalmt} - ${ticket?.cf?.cf_nw_tlb_alkhdmt}`
                            : ticket?.cf?.cf_nw_almkalmt}
                          {/* </button> */}
                        </div>
                      </td>
                      <td className='px-6 py-4 whitespace-nowrap '>
                        <div className='text-sm text-right text-altaqnya-100'>
                          {/* <button
                          onClick={() => numberHandler(ticket?.number)}
                        > */}
                          {ticket?.status}
                          {/* </button> */}
                        </div>
                      </td>
                      <td className='px-6 py-4 whitespace-nowrap '>
                        <div className='text-sm text-right text-gray-900'>
                          {ticket?.contact?.firstName +
                            ' ' +
                            ticket?.contact?.lastName}
                        </div>
                      </td>

                      <td className='px-6 py-4  break-normal max-w-sm'>
                        <div className='text-sm text-right text-gray-900'>
                          {ticket?.cf?.cf_rqm_almyl_erp || null}
                        </div>
                      </td>
                      <td className='px-4 py-4  break-normal max-w-sm'>
                        <div className='text-sm text-right  text-gray-900'>
                          {ticket?.phone}
                        </div>
                      </td>
                      <td className='px-6 py-4  break-normal max-w-sm'>
                        <div className='text-sm text-right text-gray-900'>
                          {ticket?.cf?.cf_almdynt}
                        </div>
                      </td>
                      <td className='px-6 py-4  break-normal max-w-sm'>
                        <div className='text-sm text-right text-gray-900'>
                          {ticket?.cf?.cf_aldahyt}
                        </div>
                      </td>
                      <td className='px-6 py-4 whitespace-nowrap '>
                        <div className='text-sm text-right text-gray-900'>
                          {getDatePlusHours(
                            ticket?.createdTime.split('.')[0],
                            2
                          )}
                        </div>
                      </td>
                      <td className='px-6 py-4  break-normal max-w-sm'>
                        <div className='text-sm text-right text-gray-900'>
                          {getDatePlusHours(
                            ticket?.modifiedTime.split('.')[0],
                            2
                          )}
                        </div>
                      </td>
                      <td className='px-6 py-4  break-normal max-w-sm'>
                        <div className='text-sm text-right text-gray-900'>
                          {ticket?.cf?.cf_tm_alansha_bwastt}
                        </div>
                      </td>
                      <td className='px-6 py-4 whitespace-nowrap  text-right text-sm font-medium'>
                        <button
                          onClick={() =>
                            navigate(`/ticket/${phoneNumber}/${ticket?.id}`)
                          }
                          className='text-red-600 hover:text-red-400'
                        >
                          تفاصيل
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className='flex mx-auto justify-center pt-20 pb-20'>
                <Loader />
              </div>
            )}
          </div>
          <div className='w-full pt-6 rounded h-full '>
            {/* {startDate == '' ? (
              <AllTicketsListPage
                pages={pages}
                page={page}
                keyword={keyword ? keyword : ''}
                pageSize={pageSize}
              />
            ) : (
              <div>{startDate !== ''}</div>
            )} */}
          </div>
        </div>
      </div>
      <TailwindToaster />
    </div>
  );
};

export default CalLlogsScreen;
